export enum FirebaseAuthErrorCode {
  RequiresRecentLogin = 'auth/requires-recent-login',
  UserNotFound = 'auth/user-not-found',
  UserMismatch = 'auth/user-mismatch',
  InvalidLoginCredentials = 'auth/invalid-login-credentials',
  InvalidCredential = 'auth/invalid-credential',
  WrongPassword = 'auth/wrong-password',
  EmailAlreadyInUse = 'auth/email-already-in-use',
  InvalidEmail = 'auth/invalid-email',
  WeakPassword = 'auth/weak-password',
  TooManyRequests = 'auth/too-many-requests',
  AccountExistsWithDifferentCredential = 'auth/account-exists-with-different-credential',
  NetworkRequestFailed = 'auth/network-request-failed',
  InvalidActionCode = 'auth/invalid-action-code',
  ExpiredActionCode = 'auth/expired-action-code',
}
